<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-page-editor">
            <div class="mcf-page-editor-form">
                <div class="mcf-page-editor-header">
                    <label>Appliquer une remise</label>
                </div>
                <div class="mcf-page-editor-menu">
                    <button @click="bt_save">
                        <i class="fa fa-save"></i>
                        <label>Enregistrer</label>
                    </button>
                    <button @click="bt_cancel">
                        <i class="fa fa-close"></i>
                        <label>Annuler</label>
                    </button>
                </div>
                <div class="mcf-page-editor-content">
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Remise</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-choice">
                            <label>Remise</label>
                            <input type="number" v-model="o.discount_amount" placeholder="">
                            <span @click="o.discount_type='MONEY'" v-if="o.discount_type=='PERCENT'">%</span>
                            <span @click="o.discount_type='PERCENT'" v-if="o.discount_type=='MONEY'">€</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {DateTime} from "luxon";

export default {
    props:{
        line:Object,
        cancel:Function,
        save:Function
    },
    data(){
        return {
            o: this.line
        };
    },
    created() {
        
    },
    methods:{
        bt_cancel:function(){
            this.cancel();
        },
        bt_save:function(){
            this.save(this.o);
        }
    }
}
</script>